module.exports = __webpack_public_path__ + "static/img/error.5705f8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/error.png
// module id = 155
// module chunks = 39